import stylesheet from './Layer.scss?inline';

import CustomComponent from '../../base/customComponent/CustomComponent';
import {AbstractConstructor, withLayer} from '../../base/layer/withLayer';

export class NXTLayer extends withLayer(CustomComponent as AbstractConstructor<CustomComponent>) {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const element = document.createElement('div');
        element.classList.add('layer');
        element.innerHTML = `
            <slot></slot>
        `;
        return element;
    }

}

customElements.define('nxt-layer', NXTLayer);
